module.exports = __webpack_public_path__ + "img/cp9.55fa084c.jpg";